export enum budgetPeriodEnum {
    MONTHLY = 'Monthly',
    YEARLY = 'Yearly',
    QUARTERLY = 'Quarterly'
  } 